import { render, staticRenderFns } from "./gdpr_badge.vue?vue&type=template&id=4b150f3a"
import script from "./gdpr_badge.vue?vue&type=script&lang=js"
export * from "./gdpr_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports